export default function PageContent(p: { children: React.ReactNode,
  cover?: boolean | undefined
}) {
  const cov = p.cover === true
  return (
    <div
      className={" space-y-8 lg:space-y-8 " + (cov?"p-1 flex-1 scroll-auto":"max-w-lg lg:max-w-2xl mx-auto p-8")}
    >
      {p.children}
    </div>
  );
}

